import React, { useRef, useState, useEffect } from 'react';

const OtpInput = ({otpError = false, handleOtpForm, handleOtpError = () => {}, OTPlength = 6}) => {
  const otpFields = useRef([]);
  const isKeyDown = useRef(false);
  const [otpValues, setOtpValues] = useState(Array.from({ length: OTPlength }, (x, i) => ""));

  const handleInputChange = (index, event) => { 
    handleOtpError(false)
    const input = event.target;
    if(isKeyDown.current){
      isKeyDown.current = false
      return
    }
    let otpValue = input.value;
    if(isNaN(otpValue)) {
      return;
    }
    if(input.value.length >1 ){
      otpValue = input.value[input.value.length - 1]
      }
    if (otpValue && index < otpFields.current.length - 1) {
      if(otpFields.current[index + 1]) {
        otpFields.current[index + 1].focus();
      }
    }
    if(!otpValue && otpFields.current[index - 1]) {
      if(otpFields.current[index - 1]){
        otpFields.current[index - 1].focus();
      }
    }
    const newOtpValues = [...otpValues];
    newOtpValues[index] = otpValue;
    // const allValues = newOtpValues.every((item)=> !!item)
    // if(allValues){
      handleOtpForm(newOtpValues.join(""))
    // } 
    // else {
    //   handleOtpForm(newOtpValues.join(""))
    // }
    setOtpValues(newOtpValues); 
  };

  const handleKeyDown = (index, e) => {
    if(e.key === "Backspace" && !e.target.value ) {
      isKeyDown.current = true
      if(otpFields.current[index - 1]){
        otpFields.current[index - 1].focus();
      }
    }
  }

  useEffect(()=>{
    if(otpFields?.current[0]){
      otpFields.current[0].focus();
    }
  },[])

  const createOTPBlock = () => {
    return Array.from({ length: OTPlength }, (x, i) => i);
  }

  return (
    <div className="otp-input">
      {createOTPBlock().map((index) => (
        <input
          key={index}
          className={otpError ? 'error': ""}
          value={otpValues[index]}
          ref={(ref) => (otpFields.current[index] = ref)}
          type="text"
          onKeyDown={(e) => {
            handleKeyDown(index, e)
          }}
          onChange={(e) => handleInputChange(index, e)}
        />
      ))}
    </div>
  );
};

export default OtpInput;
